import React, { useState, useEffect } from "react";
import "./FileHistory.css";

import SlButton from '@shoelace-style/shoelace/dist/react/button';
import SlDivider from '@shoelace-style/shoelace/dist/react/divider';
import SlDropdown from '@shoelace-style/shoelace/dist/react/dropdown';
import SlMenu from '@shoelace-style/shoelace/dist/react/menu';
import SlMenuItem from '@shoelace-style/shoelace/dist/react/menu-item';

import { MdMoreHoriz, MdDownload, MdDelete } from "react-icons/md"
import { IoCaretDownOutline } from "react-icons/io5";


const extractDateFields = (entry, datetimeField) => {
    // Parse as "YYYY-MM-DD HH:MM:SS", which is not ISO so convert space to "T"
    const value = entry[datetimeField];
    const date = new Date(value.replace(' ', 'T'));

    entry.year = date.getFullYear().toString();

    entry.dayName = date.toLocaleDateString("it-IT", {
        weekday: "long",
        day: "numeric",
        month: "long"
    });

    entry.uniqueday = date.toLocaleDateString("it-IT");

    entry.time = date.toLocaleTimeString("it-IT", {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });

    return entry;
}


const groupByDay = (data, dayField) => {
    // group the data by day
    return data.reduce((groups, entry) => {
        const dayString = entry[dayField];
        if (!groups[dayString]) {
            groups[dayString] = [];
        }
        groups[dayString].push(entry);
        return groups;
    }, {});
}


const MoreButton = ({ entry, onDownload, onDelete }) => {
    return (
        <SlDropdown placement="bottom-end" distance={4}>
            <SlButton 
                slot="trigger" 
                className={`dropdown-more ${entry.isNew ? 'new-entry': ''}`}
                size="small"
            >
                <MdMoreHoriz />
            </SlButton>
            <SlMenu>
                <SlMenuItem onClick={() => {onDownload(entry)}}>
                    <MdDownload className='icon'/>
                    Scarica
                </SlMenuItem>
                <SlDivider />
                <SlMenuItem className='logout' onClick={() => {onDelete(entry)}}>
                    <MdDelete className='icon'/>
                    Elimina
                </SlMenuItem>
            </SlMenu>
        </SlDropdown>
    );
}


const PAGESIZE = 5;  // number of items shown per page


const FileHistory = ({ 
    data,
    datetimeField,
    showInfo,  // array of {"icon", "field"} pairs that will be shown in each row
    onDownload,
    onDelete
}) => {

    const [dailyData, setDailyData] = useState([]);
    const [pagesToShow, setPagesToShow] = useState(1);

    // whether to show the "show more" button
    const [showMoreButton, setShowMoreButton] = useState(data.length > PAGESIZE);

    const handleShowMore = () => {
        setPagesToShow((prev) => prev + 1);
    };

    // preprocess the data
    useEffect(() => {

        // extract year and time from the datetime field
        const newData = data.map(entry => extractDateFields(entry, datetimeField));
        
        // sort the data by descending datetime
        newData.sort((a, b) => new Date(b[datetimeField]) - new Date(a[datetimeField]));

        // filter data according to the number of pages to show
        const pagesData = newData.slice(0, pagesToShow * PAGESIZE);

        // decide if there is still some hidden data
        setShowMoreButton(pagesData.length < data.length);
        
        // group the entries by day
        const newDailyData = groupByDay(pagesData, "uniqueday");

        setDailyData(newDailyData);

    }, [data, datetimeField, pagesToShow]);


    return (
        <div className="file-history">
            {Object.entries(dailyData).map(([day, entries]) => (
                <>

                <div key={day} className="day-title">
                    <span>{entries[0].dayName}</span>
                    <span className="year"> {entries[0].year}</span>
                </div>
                
                {entries.map((entry, index) => (

                    // History Entry
                    <div 
                        key={index}
                        className="history-entry"
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <span className="time">{entry.time}</span>
                            
                            <div className="info-array">
                                {showInfo.map((item, infoIndex) => (
                                    <div 
                                        className={`info-element ${entry.isNew ? 'new-entry': ''}`}
                                        key={infoIndex}
                                    >
                                        {item.icon}
                                        <span>{entry[item.field]}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <MoreButton 
                            entry={entry}
                            onDownload={onDownload}
                            onDelete={onDelete}
                        />
                    </div>

                ))}

                </>
            ))}

            {showMoreButton && (
                <SlButton 
                    variant='default' size='medium' pill
                    className="btn-show-more"
                    onClick={handleShowMore}
                >
                    <IoCaretDownOutline slot="prefix" className="icon" />
                    <span>Mostra di più</span>
                </SlButton>
            )}

        </div>
    );
};

export default FileHistory;
